<div class="container-flex">
    @if (!viewMinimized) {
        <div class="d-inline-flex py-2 route-planning-header">
            <div class="route-planning-header-container">
                <div class="d-flex w-100 ml-3 my-auto">
                    <app-route-key-number
                        translation="ALLOCATED_VISITS"
                        tooltip="TOTAL_NUMBER_OF_ALLOCATED_TASKS"
                        [whiteBackground]="true"
                        [compareValue]="routeLength"
                        [inverseColor]="true"
                    >
                        <ng-container content>
                            <div>
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.allocatedVisits }}
                            </span>{{ "VISITS" | translate }}
                            </div>
                        </ng-container>
                    </app-route-key-number>
                    <app-route-key-number
                        translation="TOTAL_TASK_TIME"
                        tooltip="TOTAL_TASK_TIME"
                        [whiteBackground]="true"
                        [compareValue]="routes ? routes.totalKeyNumbers.totalPatientTime : undefined"
                        [inverseColor]="true"
                    >
                        <ng-container content>
                            <div class="d-inline-flex">
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.totalTaskTime[0] }}
                            </span>
                                <div>{{ "HOURS_SHORT" | translate }}&nbsp;</div>
                            </div>
                            <div class="d-inline-flex">
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.totalTaskTime[1] }}
                            </span>{{ "MINUTES_SHORT" | translate }}&nbsp;
                            </div>
                        </ng-container>
                    </app-route-key-number>
                    <app-route-key-number
                        translation="LATE_ARRIVALS"
                        tooltip="LATE_ARRIVALS_OBJECTIVE_INFO"
                        [whiteBackground]="true"
                        [compareValue]="routes ? routes.totalKeyNumbers.totalTimeBreakingTimeWindowsInSeconds : undefined"
                    >
                        <ng-container content>
                            <div class="d-inline-flex">
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.accurateArrivals[0] }}
                            </span>
                                <div>{{ "HOURS_SHORT" | translate }}&nbsp;</div>
                            </div>
                            <div class="d-inline-flex">
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.accurateArrivals[1] }}
                            </span>
                                <div>{{ "MINUTES_SHORT" | translate }}</div>
                            </div>
                        </ng-container>
                    </app-route-key-number>
                    <app-route-key-number
                        translation="TRAVEL_TIME"
                        tooltip="{{travelTimeTransportService.formatTransportTooltip(transportTravelTime)}}"
                        [whiteBackground]="true"
                        [compareValue]="routes ? routes.totalKeyNumbers.totalTravelTimeSeconds : undefined"
                    >
                        <ng-container content>
                            <div class="d-inline-flex">
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.travelTime[0] }}
                            </span>
                                <div>{{ "HOURS_SHORT" | translate }}&nbsp;</div>
                            </div>
                            <div class="d-inline-flex">
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.travelTime[1] }}
                            </span>
                                <div>{{ "MINUTES_SHORT" | translate }}</div>
                            </div>
                        </ng-container>
                    </app-route-key-number>
                    <app-route-key-number
                        translation="VISIT_CONTINUITY"
                        tooltip="VISIT_CONTINUITY_OBJECTIVE_INFO"
                        [textParam]="routeKeyNumberWeights.visitContinuity"
                        [whiteBackground]="true"
                        [compareValue]="routes ? routes.totalKeyNumbers.totalNumberOfPatientsVisitedByEmployeesNotInPrimaryGroup : undefined"
                    >
                        <ng-container content>
                            <div>
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.visitContinuity }}
                            </span>
                                {{ "X_NEW_VISITS" | translate }}
                            </div>
                        </ng-container>
                    </app-route-key-number>
                    @if (routeKeyNumberWeights.overMaxEmployeeCount) {
                        <app-route-key-number
                            translation="ABOVE_MAX"
                            tooltip="ABOVE_MAX_VISIT_CONTINUITY_OBJECTIVE_INFO"
                            [whiteBackground]="true"
                            [compareValue]="routes ? employeeKeyNumbers.numberOfPatientsVisitedByOverMaxEmployees : undefined"
                        >
                            <ng-container content>
                                <div>
                                <span class="key-number-content">
                                    {{ routeKeyNumberWeights.overMaxEmployeeCount }}
                                </span>
                                    {{ "VISITS" | translate }}
                                </div>
                            </ng-container>
                        </app-route-key-number>
                    }
                    <app-route-key-number
                        translation="OVERQUALIFICATION"
                        tooltip="OVERQUALIFICATION_OBJECTIVE_INFO"
                        [whiteBackground]="true"
                        [compareValue]="routes ? routes.totalKeyNumbers.numberOfTasksWithOverqualifiedWork : undefined"
                    >
                        <ng-container content>
                            <div>
                            <span class="key-number-content">
                                {{ routeKeyNumberWeights.correctCompetence }}
                            </span>
                                {{ "VISITS" | translate }}
                            </div>
                        </ng-container>
                    </app-route-key-number>
                    @if (rosterInInstance) {
                        <app-route-key-number
                            translation="DIFFERENT_ROSTER_DEPARTMENT"
                            tooltip="DIFFERENT_ROSTER_DEPARTMENT_OBJECTIVE_INFO"
                            [whiteBackground]="true"
                            [compareValue]="routes ? routes.totalKeyNumbers.numberOfTasksWithDifferentRosterDepartment : undefined"
                        >
                            <ng-container content>
                                <div>
                                <span class="key-number-content">
                                    {{ routeKeyNumberWeights.differentRosterTasks }}
                                </span>
                                    {{ "PROGRESS_DIFFERENT_DEPARTMENT" | translate }}
                                </div>
                            </ng-container>
                        </app-route-key-number>
                    }
                </div>
            </div>
            <div class="d-flex justify-content-end my-auto flex-column test">
                @if (travelTimeImprovementsCount$ | async; as improvementsCount) {
                    <app-button
                        class="mr-2"
                        label="BUTTON_IMPROVE_ROUTES_EFFICIENCY"
                        [notification]="true"
                        [notificationLabel]="improvementsCount"
                        [disabled]="manualChanges"
                        (clicked)="openTravelTimeImprovementsModal()"
                    ></app-button>
                }
                <button [ngClass]="{'medium': breakpointValue < 2}"
                        (click)="openExportModal()"
                        type="button" class="btn btn-default print-btn mx-auto my-1">
                    {{ "PRINT" | translate }}
                </button>
            </div>
        </div>
    }
    <div class="row h-100 route-planning-panel" cdkDropListGroup>
        <div class="col-md-5 container-flex h-100">
            <app-route-planning-employees
                class="container-flex mb-2"
                (reloadRoutes)="loadRoutesInfo($event)"
                (select)="employeeSelected($event)"
            ></app-route-planning-employees>
            <app-route-planning-unallocated-tasks
                class="container-flex test"
                [unallocatedTasks]="routes?.nonAllocatedTasksInfo"
                [employee]="selectedEmployee"
                [updating]="changingEmployeeTasks"
                [saving]="updating"
                [dragDisabled]="!manualChangesEnabled"
                (reloadRoutes)="loadRoutesInfo($event, true)"
            ></app-route-planning-unallocated-tasks>
        </div>

        <div class="col-md-7 container-flex">
            <app-route-planning-info
                class="container-flex"
                [employee]="selectedEmployee"
                [employeeTasks]="selectedEmployeeTasks"
                [employeeKeyNumbers]="employeeKeyNumbers"
                [dragDisabled]="!manualChangesEnabled"
                [saving]="updating"
                (reloadRoutes)="loadRoutesInfo($event, true)"
                [routes]="routes"
                (minimizedViewEmitter)="updateViewState()"
            ></app-route-planning-info>
        </div>
    </div>
</div>
